import basic from './basic/en';

// Public pages
import barbara from '../../modules/site/barbara/i18n/en';
import concept from '../../modules/site/concept/i18n/en';
import onlineCourse from '../../modules/site/onlineCourse/i18n/en';
import thankYou from '../../modules/site/thankYou/i18n/en';
import paymentFailure from '../../modules/site/paymentFailure/i18n/en';
import livecourse from '../../modules/site/livecourse/i18n/en';
import workbook from '../../modules/site/workbook/i18n/en';
import summary from '../../modules/site/summary/i18n/en';
import textbook from '../../modules/site/textbook/i18n/en';
import contact from '../../modules/site/contact/i18n/en';
import press from '../../modules/site/press/i18n/en';
import tc from '../../modules/site/tc/i18n/en';
import policies from '../../modules/site/policies/i18n/en';
import dashboard from '../../modules/dashboard/i18n/en';

// Common components
import nav from '../../components/nav/i18n/en';
import header from '../../components/header/i18n/en';
import footer from '../../components/footer/i18n/en';


// Section 1
import imposingTheStructure from './../../modules/courses/1/1a/imposingTheStructure/i18n/en';
import cementingTheRules from './../../modules/courses/1/1b/cementingTheRules/i18n/en';
import pickingOutThePoints from './../../modules/courses/1/1c/pickingOutThePoints/i18n/en';
import graspingTheMessage from './../../modules/courses/1/1d/graspingTheMessage/i18n/en';


// Section 1 diagrams
import diagram1A1 from './../../components/diagrams/1/1a/diagram1/i18n/en';
import diagram1A2 from './../../components/diagrams/1/1a/diagram2/i18n/en';
import diagram1A3 from './../../components/diagrams/1/1a/diagram3/i18n/en';
import diagram1A4 from './../../components/diagrams/1/1a/diagram4/i18n/en';
import diagram1B1 from './../../components/diagrams/1/1b/diagram1/i18n/en';
import diagram1B2 from './../../components/diagrams/1/1b/diagram2/i18n/en';
import diagram1B3 from './../../components/diagrams/1/1b/diagram3/i18n/en';
import diagram1B4 from './../../components/diagrams/1/1b/diagram4/i18n/en';
import diagram1C1 from './../../components/diagrams/1/1c/diagram1/i18n/en';
import diagram1C2 from './../../components/diagrams/1/1c/diagram2/i18n/en';
import diagram1C3 from './../../components/diagrams/1/1c/diagram3/i18n/en';
import diagram1C4 from './../../components/diagrams/1/1c/diagram4/i18n/en';
import diagram1D1 from './../../components/diagrams/1/1d/diagram1/i18n/en';
import diagram1D2 from './../../components/diagrams/1/1d/diagram2/i18n/en';
import diagram1D3 from './../../components/diagrams/1/1d/diagram3/i18n/en';
import diagram1D4 from './../../components/diagrams/1/1d/diagram4/i18n/en';
import diagram1D5 from './../../components/diagrams/1/1d/diagram5/i18n/en';


// Section 2
import ideasFitTogether from './../../modules/courses/2/2a/ideasFitTogether/i18n/en';
import creatingQuestion from './../../modules/courses/2/2b/creatingQuestion/i18n/en';


// Section 2 diagrams
import diagram2B1 from './../../components/diagrams/2/2b/diagram1/i18n/en';
import diagram2B2 from './../../components/diagrams/2/2b/diagram2/i18n/en';
import diagram2B3 from './../../components/diagrams/2/2b/diagram3/i18n/en';
import diagram2B4 from './../../components/diagrams/2/2b/diagram4/i18n/en';
import diagram2B5 from './../../components/diagrams/2/2b/diagram5/i18n/en';
import diagram2B6 from './../../components/diagrams/2/2b/diagram6/i18n/en';
import diagram2B7 from './../../components/diagrams/2/2b/diagram7/i18n/en';
import diagram2B8 from './../../components/diagrams/2/2b/diagram8/i18n/en';
import diagram2B9 from './../../components/diagrams/2/2b/diagram9/i18n/en';
import diagram2B10 from './../../components/diagrams/2/2b/diagram10/i18n/en';

// Section 3
import supportingPoints from './../../modules/courses/3/3zero/supportingPoints/i18n/en';
import deductiveReasoning from './../../modules/courses/3/3a1/deductiveReasoning/i18n/en';
import summarizingDeductive from './../../modules/courses/3/3a2/summarizingDeductive/i18n/en';
import unearthingEmbeddedArguments from './../../modules/courses/3/3a3/unearthingEmbeddedArguments/i18n/en';
import inductiveReasoning from './../../modules/courses/3/3b1/inductiveReasoning/i18n/en';
import identifyingInductivePoints from './../../modules/courses/3/3b2/identifyingInductivePoints/i18n/en';
import inductionFromDeduction from './../../modules/courses/3/3b3/inductionFromDeduction/i18n/en';
import deductionToInduction from './../../modules/courses/3/3b4/deductionToInduction/i18n/en';
import avoidingDeductiveArguments from './../../modules/courses/3/3c/avoidingDeductiveArguments/i18n/en';

// Section 3 diagrams
import diagram3A11 from './../../components/diagrams/3/3a1/diagram1/i18n/en';
import diagram3A12 from './../../components/diagrams/3/3a1/diagram2/i18n/en';
import diagram3A13 from './../../components/diagrams/3/3a1/diagram3/i18n/en';
import diagram3A14 from './../../components/diagrams/3/3a1/diagram4/i18n/en';
import diagram3A15 from './../../components/diagrams/3/3a1/diagram5/i18n/en';
import diagram3A16 from './../../components/diagrams/3/3a1/diagram6/i18n/en';
import diagram3A17 from './../../components/diagrams/3/3a1/diagram7/i18n/en';
import diagram3A18 from './../../components/diagrams/3/3a1/diagram8/i18n/en';
import diagram3A19 from './../../components/diagrams/3/3a1/diagram9/i18n/en';
import diagram3A110 from './../../components/diagrams/3/3a1/diagram10/i18n/en';
import diagram3A111 from './../../components/diagrams/3/3a1/diagram11/i18n/en';
import diagram3A112 from './../../components/diagrams/3/3a1/diagram12/i18n/en';

import diagram3A21 from './../../components/diagrams/3/3a2/diagram1/i18n/en';
import diagram3A22 from './../../components/diagrams/3/3a2/diagram2/i18n/en';
import diagram3A23 from './../../components/diagrams/3/3a2/diagram3/i18n/en';
import diagram3A24 from './../../components/diagrams/3/3a2/diagram4/i18n/en';
import diagram3A25 from './../../components/diagrams/3/3a2/diagram5/i18n/en';

import diagram3A31 from './../../components/diagrams/3/3a3/diagram1/i18n/en';
import diagram3A32 from './../../components/diagrams/3/3a3/diagram2/i18n/en';
import diagram3A33 from './../../components/diagrams/3/3a3/diagram3/i18n/en';
import diagram3A34 from './../../components/diagrams/3/3a3/diagram4/i18n/en';
import diagram3A35 from './../../components/diagrams/3/3a3/diagram5/i18n/en';
import diagram3A36 from './../../components/diagrams/3/3a3/diagram6/i18n/en';

import diagram3B11 from './../../components/diagrams/3/3b1/diagram1/i18n/en';
import diagram3B12 from './../../components/diagrams/3/3b1/diagram2/i18n/en';
import diagram3B13 from './../../components/diagrams/3/3b1/diagram3/i18n/en';
import diagram3B14 from './../../components/diagrams/3/3b1/diagram4/i18n/en';
import diagram3B15 from './../../components/diagrams/3/3b1/diagram5/i18n/en';
import diagram3B16 from './../../components/diagrams/3/3b1/diagram6/i18n/en';
import diagram3B17 from './../../components/diagrams/3/3b1/diagram7/i18n/en';

import diagram3B21 from './../../components/diagrams/3/3b2/diagram1/i18n/en';
import diagram3B22 from './../../components/diagrams/3/3b2/diagram2/i18n/en';
import diagram3B23 from './../../components/diagrams/3/3b2/diagram3/i18n/en';
import diagram3B24 from './../../components/diagrams/3/3b2/diagram4/i18n/en';
import diagram3B25 from './../../components/diagrams/3/3b2/diagram5/i18n/en';

import diagram3B31 from './../../components/diagrams/3/3b3/diagram1/i18n/en';
import diagram3B32 from './../../components/diagrams/3/3b3/diagram2/i18n/en';
import diagram3B33 from './../../components/diagrams/3/3b3/diagram3/i18n/en';
import diagram3B34 from './../../components/diagrams/3/3b3/diagram4/i18n/en';
import diagram3B35 from './../../components/diagrams/3/3b3/diagram5/i18n/en';
import diagram3B36 from './../../components/diagrams/3/3b3/diagram6/i18n/en';
import diagram3B37 from './../../components/diagrams/3/3b3/diagram7/i18n/en';

import diagram3B41 from './../../components/diagrams/3/3b4/diagram1/i18n/en';
import diagram3B42 from './../../components/diagrams/3/3b4/diagram2/i18n/en';
import diagram3B43 from './../../components/diagrams/3/3b4/diagram3/i18n/en';
import diagram3B44 from './../../components/diagrams/3/3b4/diagram4/i18n/en';
import diagram3B45 from './../../components/diagrams/3/3b4/diagram5/i18n/en';


// Section 4
import practiceInSeeing from './../../modules/courses/4/4a/practiceInSeeing/i18n/en';
import findingReadersQuestion from './../../modules/courses/4/4b1/findingReadersQuestion/i18n/en';
import spottingSCQ from './../../modules/courses/4/4b2/spottingSCQ/i18n/en';
import s4c1 from './../../modules/courses/4/4c1/i18n/en';
import practiceInSeeing3 from './../../modules/courses/4/4c2/practiceInSeeing3/i18n/en';

// Section 4 diagrams
import diagram4a1 from './../../components/diagrams/4/4a/diagram1/i18n/en';
import diagram4a2 from './../../components/diagrams/4/4a/diagram2/i18n/en';
import diagram4a3 from './../../components/diagrams/4/4a/diagram3/i18n/en';
import diagram4a4 from './../../components/diagrams/4/4a/diagram4/i18n/en';
import diagram4a5 from './../../components/diagrams/4/4a/diagram5/i18n/en';

// Section 5
import defineProblem from './../../modules/courses/5/5a/defineProblem/i18n/en';
import practiceDefiningProblem from './../../modules/courses/5/5b/practiceDefiningProblem/i18n/en';
import practiceDefiningProblem2 from './../../modules/courses/5/5c/practiceDefiningProblem2/i18n/en';
import writingProposalsPlans from './../../modules/courses/5/5d/writingProposalsPlans/i18n/en';


// Section 5 diagrams
import diagram5A1 from './../../components/diagrams/5/5a/diagram1/i18n/en';
import diagram5A2 from './../../components/diagrams/5/5a/diagram2/i18n/en';
import diagram5A3 from './../../components/diagrams/5/5a/diagram3/i18n/en';

import diagram5B1 from './../../components/diagrams/5/5b/diagram1/i18n/en';
import diagram5B2 from './../../components/diagrams/5/5b/diagram2/i18n/en';
import diagram5B3 from './../../components/diagrams/5/5b/diagram3/i18n/en';
import diagram5B4 from './../../components/diagrams/5/5b/diagram4/i18n/en';
import diagram5B5 from './../../components/diagrams/5/5b/diagram5/i18n/en';
import diagram5B6 from './../../components/diagrams/5/5b/diagram6/i18n/en';

import diagram5C1 from './../../components/diagrams/5/5c/diagram1/i18n/en';
import diagram5C2 from './../../components/diagrams/5/5c/diagram2/i18n/en';
import diagram5C3 from './../../components/diagrams/5/5c/diagram3/i18n/en';
import diagram5C4 from './../../components/diagrams/5/5c/diagram4/i18n/en';
import diagram5C5 from './../../components/diagrams/5/5c/diagram5/i18n/en';
import diagram5C6 from './../../components/diagrams/5/5c/diagram6/i18n/en';
import diagram5C7 from './../../components/diagrams/5/5c/diagram7/i18n/en';
import diagram5C8 from './../../components/diagrams/5/5c/diagram8/i18n/en';

import diagram5D1 from './../../components/diagrams/5/5d/diagram1/i18n/en';
import diagram5D2 from './../../components/diagrams/5/5d/diagram2/i18n/en';
import diagram5D3 from './../../components/diagrams/5/5d/diagram3/i18n/en';
import diagram5D4 from './../../components/diagrams/5/5d/diagram4/i18n/en';
import diagram5D5 from './../../components/diagrams/5/5d/diagram5/i18n/en';
import diagram5D6 from './../../components/diagrams/5/5d/diagram6/i18n/en';

import course6lecture from './../../modules/courses/6/lecture/i18n/en';
import identifyingLogicaOrder from './../../modules/courses/6/identifyingLogicaOrder/i18n/en';


export let i18nEN = angular.extend({},
    basic,

    // Common components and public pages
    nav,
    footer,
    header,
    barbara,
    concept,
    onlineCourse,
    thankYou,
    paymentFailure,
    livecourse,
    workbook,
    summary,
    textbook,
    contact,
    press,
    tc,
    policies,
    dashboard,

    // Section 1
    imposingTheStructure,
    cementingTheRules,
    pickingOutThePoints,
    graspingTheMessage,


    // Section 1 diagrams
    diagram1A1,
    diagram1A2,
    diagram1A3,
    diagram1A4,
    diagram1B1,
    diagram1B2,
    diagram1B3,
    diagram1B4,
    diagram1C1,
    diagram1C2,
    diagram1C3,
    diagram1C4,
    diagram1D1,
    diagram1D2,
    diagram1D3,
    diagram1D4,
    diagram1D5,


    // Section 2
    ideasFitTogether,
    creatingQuestion,


    // Section 2 diagrams
    diagram2B1,
    diagram2B2,
    diagram2B3,
    diagram2B4,
    diagram2B5,
    diagram2B6,
    diagram2B7,
    diagram2B8,
    diagram2B9,
    diagram2B10,


    // Section 3
    supportingPoints,
    deductiveReasoning,
    summarizingDeductive,
    unearthingEmbeddedArguments,
    inductiveReasoning,
    identifyingInductivePoints,
    inductionFromDeduction,
    deductionToInduction,
    avoidingDeductiveArguments,


    // Section 3 diagrams
    diagram3A11,
    diagram3A12,
    diagram3A13,
    diagram3A14,
    diagram3A15,
    diagram3A16,
    diagram3A17,
    diagram3A18,
    diagram3A19,
    diagram3A110,
    diagram3A111,
    diagram3A112,
    diagram3A21,
    diagram3A22,
    diagram3A23,
    diagram3A24,
    diagram3A25,
    diagram3A31,
    diagram3A32,
    diagram3A33,
    diagram3A34,
    diagram3A35,
    diagram3A36,
    diagram3B11,
    diagram3B12,
    diagram3B13,
    diagram3B14,
    diagram3B15,
    diagram3B16,
    diagram3B17,
    diagram3B21,
    diagram3B22,
    diagram3B23,
    diagram3B24,
    diagram3B25,
    diagram3B31,
    diagram3B32,
    diagram3B33,
    diagram3B34,
    diagram3B35,
    diagram3B36,
    diagram3B37,
    diagram3B41,
    diagram3B42,
    diagram3B43,
    diagram3B44,
    diagram3B45,


    // Section 4
    practiceInSeeing,
    practiceInSeeing3,
    findingReadersQuestion,
    spottingSCQ,
    s4c1,

    // Section 4 diagrams

    diagram4a1,
    diagram4a2,
    diagram4a3,
    diagram4a4,
    diagram4a5,

    // Section 5
    defineProblem,
    practiceDefiningProblem,
    practiceDefiningProblem2,
    writingProposalsPlans,


    // Section 5 diagrams
    diagram5A1,
    diagram5A2,
    diagram5A3,
    diagram5B1,
    diagram5B2,
    diagram5B3,
    diagram5B4,
    diagram5B5,
    diagram5B6,
    diagram5C1,
    diagram5C2,
    diagram5C3,
    diagram5C4,
    diagram5C5,
    diagram5C6,
    diagram5C7,
    diagram5C8,
    diagram5D1,
    diagram5D2,
    diagram5D3,
    diagram5D4,
    diagram5D5,
    diagram5D6,

    // Unit 6
    course6lecture,
    identifyingLogicaOrder
);



// WEBPACK FOOTER //
// ./client/app/core/i18n/i18n.en.files.js